import React, { useContext, useState } from "react";
import {
  Box,
  Button,
  CardActions,
  CardContent,
  // Divider,
  Grid,
  // Link,
  TextField,
  Typography,
} from "@material-ui/core";
import { red } from "@material-ui/core/colors";
// import { ArrowForward } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";

// Contexts
import DomainContext from "../../../context/domains/DomainContext";

// Components
import DomainRemoveBox from "./DomainRemoveBox";

const DomainEdit = ({ handleEdit, handleUpdate }) => {
  const useStyles = makeStyles((theme) => ({
    cardAction: {
      borderTop: "1px solid",
      borderColor: theme.palette.action.selected,
      backgroundColor: theme.palette.action.hover,
      padding: "15px 20px",
    },
    removeButton: {
      color: theme.palette.getContrastText(red[500]),
      backgroundColor: red[500],
      "&:hover": {
        backgroundColor: red[700],
      },
    },
  }));
  const classes = useStyles();

  const {
    selected_domain,
    form_data,
    setFormData,
    form_error,
    setFormError,
    deleteDomain,
    updateDomain,
  } = useContext(DomainContext);

  const [open_remove_box, setOpenRemoveBox] = useState(false);

  const closeRemoveBox = () => {
    setOpenRemoveBox(false);
  };

  // Remove Domain
  const remove = async () => {
    closeRemoveBox();
    await deleteDomain();
    handleUpdate();
  };

  // Open Remove Box
  const handleRemove = (e) => {
    e.preventDefault();

    if (selected_domain) {
      setOpenRemoveBox(true);
    }
  };

  const save = async (e) => {
    e.preventDefault();

    // Error Checking
    let noError = true;

    for (let key in form_error) {
      const error = form_error[key];

      if (error) {
        noError = false;
        break;
      }
    }

    // Field Checking
    let filled = true;

    for (let key in form_data) {
      const value = form_data[key];

      if (value === "") {
        filled = false;
        form_error[key] = "Field cannot be empty!";
      }
    }

    // Value Checking
    let changes = false;

    for (let key in form_data) {
      const a = form_data[key];
      const b = selected_domain[key];

      if (a !== b) {
        changes = true;
        break;
      }
    }

    // Valid To Submit
    if (noError && filled) {
      await updateDomain(changes);
      if (changes) handleUpdate();
    } else setFormError(form_error);
  };

  const handleChange = (e) => {
    const id = e.target.id;
    let value = e.target.value;

    if (id === "name") {
      form_data[id] = value.trim();
      // } else {
      //   form_data[id] = value;
    }

    switch (id) {
      case "name":
        if (value.length < 1) {
          form_error[id] = "Field cannot be empty!";
        } else if (value.length > 50) {
          form_error[id] = "Name cannot be more than 50 characters!";
        } else {
          form_error[id] = "";
        }
        break;

      default:
        break;
    }

    setFormData(form_data);
    setFormError(form_error);
  };

  return (
    <Box component="form" noValidate autoComplete="off" onSubmit={save}>
      <DomainRemoveBox
        open_remove_box={open_remove_box}
        closeRemoveBox={closeRemoveBox}
        remove={remove}
      />
      <CardContent>
        <Grid container direction="column" spacing={1}>
          <Grid item container alignItems="center">
            <Grid item xs={2}>
              <Typography variant="body1"> Domain </Typography>{" "}
            </Grid>{" "}
            <Grid item xs={10}>
              <TextField
                variant="outlined"
                margin="dense"
                size="small"
                fullWidth
                required
                id="name"
                onChange={handleChange}
                value={form_data.name}
                error={form_error.name ? true : false}
                helperText={form_error.name}
              />{" "}
            </Grid>{" "}
          </Grid>
        </Grid>
      </CardContent>
      {/* Button Actions */}{" "}
      <CardActions className={classes.cardAction}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Button
              variant="contained"
              className={classes.removeButton}
              onClick={(e) => handleRemove(e)}
            >
              Remove{" "}
            </Button>{" "}
          </Grid>
          <Grid item>
            <Button variant="contained" onClick={() => handleEdit(null, null)}>
              Cancel{" "}
            </Button>{" "}
            &emsp;{" "}
            <Button variant="contained" color="primary" type="submit">
              Save{" "}
            </Button>{" "}
          </Grid>{" "}
        </Grid>{" "}
      </CardActions>{" "}
    </Box>
  );
};

export default DomainEdit;
